import withStyles from '@material-ui/core/styles/withStyles';
import {
  MenuItem,
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import CustomTextarea from 'components/CustomTextarea/CustomTextarea';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Accordion from 'components/Accordion/Accordion';
import WaitDialog from 'conten/components/WaitDialog.jsx';
import TituloPagina2 from 'conten/components/TituloPagina2';
import AplicarSeguridad from 'conten/components/AplicarSeguridad';
import { connect } from 'react-redux';
import { guardarSuscripcionPlaca, listarPlacasActivas, listarPlanesActivos } from './SuscripcionPlacaActions';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx';
import { addMessage } from 'conten/mensajes/MessagesActions';
import React from 'react';
import CustomSelect from 'components/CustomSelect/CustomSelect';
import Alerta2Botones from 'conten/components/Alerta2Botones';

class SuscripcionPlacaAdministrar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textoAlerta: 'Un momento por favor ...',
      suscripcionPlaca: {
        activo: true,
        id_placa: 0,
        id_plan: 0,
        id_usuario_recauda: 1,
        informacion: ''
      },
      placas: [],
      plan: [],
      placaSeleccionada: null,
      planSeleccionado: null,
      contenidoAlerta: null,
    };
  }

  componentDidMount() {
    this.traerDatosServidor();
  }
  traerDatosServidor = () => {
    this.props.listarPlanesActivos();
    this.props.listarPlacasActivas();
    const { suscripcionPlacaState } = this.props;
    const { placas = [] } =
      suscripcionPlacaState || {};
    const { plan = [] } =
      suscripcionPlacaState || {};
    this.setState({ placas })
    this.setState({ plan })


  };

  handlePlacaSeleccionada = (event) => {
    const placaSeleccionada = this.state.placas.find(
      (placa) => placa.id === parseInt(event.target.value, 10)
    );
    this.setState((prevState) => ({
      placaSeleccionada,
      suscripcionPlaca: {
        ...prevState.suscripcionPlaca,
        id_placa: placaSeleccionada ? placaSeleccionada.id : 0
      }
    }));

  };

  handlePlanSeleccionado = (event) => {
    const planSeleccionado = this.state.plan.find(
      (plan) => plan.id === parseInt(event.target.value, 10)
    );
    this.setState((prevState) => ({
      planSeleccionado,
      suscripcionPlaca: {
        ...prevState.suscripcionPlaca,
        id_plan: planSeleccionado ? planSeleccionado.id : 0
      }
    }));
  };
  preguntarCerrarRecaudo = (planSeleccionado, placaSeleccionada) => {
    var contenidoAlerta = (
      <Alerta2Botones
        key="preguntarCerrarRecaudo"
        titulo="Completar venta de plan"
        mensaje={
          <>
            {"¿Desea completar la venta del plan para la placa: " + placaSeleccionada.placa + "?"}
            <br />
            {"El total a pagar es de: " + planSeleccionado.valor}
          </>
        }
        textoBotonAceptar="Aceptar"
        textoBotonCancelar="Cancelar"
        eventoBotonAceptar={this.completarVenta}
        eventoBotonCancelar={this.cancelarCerrarRecaudo}
        iconoAceptar={<CheckCircleIcon />}
        iconoCancelar={<CancelIcon />}
      />
    );
    this.setState({ contenidoAlerta: contenidoAlerta });
  };

  completarVenta = () => {
    this.props.guardarSuscripcionPlaca(this.state.suscripcionPlaca, (resultado) => {
      if (resultado === 'OK') {
        this.props.history.goBack();
      }
    });
  }
  cerrarVentanaPregunta = () => {
    this.setState({ contenidoAlerta: null });
  };

  cancelarCerrarRecaudo = (_contenido) => {
    this.cerrarVentanaPregunta();
  };

  cambioContenidoSuscripcionPlaca = (valor, campo,) => {
    console.log(this.state.suscripcionPlaca)
    this.setState((prevState) => ({
      suscripcionPlaca: {
        ...prevState.suscripcionPlaca,
        [campo]: valor,
      },
    }));
  };
  validarContenidos = () => {

    const { suscripcionPlaca } = this.state;

    // Validar la placa
    if (!suscripcionPlaca.id_placa || suscripcionPlaca.id_placa === 0) {
      throw new Error("La placa es obligatoria.");
    }

    // Validar la placa
    if (!suscripcionPlaca.id_plan || suscripcionPlaca.id_plan === 0) {
      throw new Error("El plan es obligatorio");
    }
    const regexAuto = /^[A-Z]{3}[0-9]{3}$/;
    const regexMoto1 = /^[A-Z]{3}[0-9]{2}[A-Z]$/;
    const regexMoto2 = /^[A-Z]{3}[0-9]{2}$/;

    // Validar si es carro
    if (regexAuto.test(this.state.placaSeleccionada.placa)) {
      if (!this.state.planSeleccionado.es_carro) {
        throw new Error(
          "El plan seleccionado no es para carro, pero la placa tiene formato de carro."
        );
      }
    }
    // Validar si es moto
    else if (regexMoto1.test(this.state.placaSeleccionada.placa)) {
      if (this.state.planSeleccionado.es_carro) {
        throw new Error(
          "El plan seleccionado no es para moto, pero la placa tiene formato de moto."
        );
      }
    }
    // Validar si es moto
    else if (regexMoto2.test(this.state.placaSeleccionada.placa)) {
      if (this.state.planSeleccionado.es_carro) {
        throw new Error(
          "El plan seleccionado no es para moto, pero la placa tiene formato de moto."
        );
      }
    }
    // Si no cumple ninguno de los formatos, es inválido
    else {
      throw new Error(
        "La placa seleccionada no tiene un formato válido. Ejemplo para carro: ABC123 o ABC-123. Ejemplo para moto: ABC12A o ABC-12A."
      );
    }

    // Si pasa todas las validaciones, no hace nada
    return true;

  };

  guardarCambios = () => {
    try {
      this.validarContenidos();

      this.preguntarCerrarRecaudo(this.state.planSeleccionado, this.state.placaSeleccionada)

    } catch (error) {
      // Manejar errores de validación
      this.abrirAlerta(error.message);
    }
  };


  abrirAlerta = (texto, tipo = 'error') => {
    this.props.addMessage({ variant: tipo, message: texto });

  };

  render() {
    const { classes } = this.props;


    return (
      <GridItem xs={12}>
        {this.props.isActivityIndicatorShown && (
          <WaitDialog text={this.state.textoAlerta} />
        )}
        {this.state.contenidoAlerta}
        <AplicarSeguridad />
        <Card>
          <CardHeader icon>
            <CardIcon
              color='primary'
              onClick={() => this.props.history.goBack()}
              style={{ cursor: 'pointer' }}
            >
              <b>{'Ver listado'}</b>
              <DirectionsCar />
            </CardIcon>
            <TituloPagina2
              texto='Datos de placas'
              color='primary'
              classes={classes}
            />
          </CardHeader>

          <CardBody>
            <Accordion
              active={0}
              collapses={[
                {
                  title: 'Crear suscripcion',
                  content: (
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomSelect
                          key="id_placa"
                          success
                          labelText="* Seleccione la placa"
                          id="id_placa"

                          formControlProps={{
                            fullWidth: true,
                          }}
                          isInputText = {true}
                          inputProps={{
                            name: "id_placa",
                            id: "id_placa",
                            value: this.state.suscripcionPlaca.id_placa || '',
                            onChange: (e) => this.handlePlacaSeleccionada(e),
                          }}
                          
                          selectContent={this.state.placas.map((placa) => (
                            <MenuItem key={placa.id} value={placa.id} onKeyDown={(e) => e.stopPropagation()}>
                              {placa.placa}
                            </MenuItem>
                          ))}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={6} md={6}>
                        <CustomSelect
                          key="id_plan"
                          success
                          labelText="* Seleccione el plan"
                          id="id_plan"

                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: "id_plan",
                            id: "id_plan",
                            value: this.state.suscripcionPlaca.id_plan || '',
                            onChange: (e) => this.handlePlanSeleccionado(e),
                          }}
                          selectContent={this.state.plan.map((plan) => (
                            <MenuItem key={plan.id} value={plan.id}>
                              {plan.nombre}
                            </MenuItem>
                          ))}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={12}>
                        <CustomTextarea
                          labelText='Información'
                          id='informacion'
                          success
                          formControlProps={{ fullWidth: true }}
                          inputProps={{
                            value: this.state.suscripcionPlaca.informacion,
                            onChange: (e) =>
                              this.cambioContenidoSuscripcionPlaca(
                                e.target.value,
                                'informacion'
                              ),
                          }}
                        />
                      </GridItem>


                      <GridItem xs={12} sm={6} md={6}>
                        <Button
                          type='button'
                          onClick={this.guardarCambios}
                          color='success'
                        >
                          <SaveIcon />
                          Guardar
                        </Button>
                      </GridItem>
                    </GridContainer>
                  ),
                },
              ]}
            />
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const mapStateToProps = (state) => ({
  suscripcionPlacaState: state.suscripcionPlacaState,
});

const mapDispatchToProps = (dispatch) => {
  return {
    listarPlacasActivas: (onSuccess) => dispatch(listarPlacasActivas(onSuccess)),
    listarPlanesActivos: (onSuccess) => dispatch(listarPlanesActivos(onSuccess)),
    guardarSuscripcionPlaca: (placa, onSuccess) => (
      dispatch(guardarSuscripcionPlaca(placa, onSuccess))),
    addMessage: (content) => dispatch(addMessage(content)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SuscripcionPlacaAdministrar)
);
